import { Directive, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { alert as notieAlert } from 'notie';

import * as fromStore from '../store';
import { Subscription } from 'rxjs';

@Directive({
  /*
    Intentionally overriding directive-selector linting since it is meant to match an HTML element.

    "Do spell non-element selectors in lower camel case unless the selector is meant to match a native HTML attribute." from https://angular.io/guide/styleguide#directive-selectors
  */
  selector: 'ot-notification' // tslint:disable-line directive-selector
})
export class NotificationDirective implements OnInit, OnDestroy {
  subscription: Subscription;

  constructor(private store: Store<fromStore.AppState>) {}

  ngOnInit() {
    this.subscription = this.store
      .select(fromStore.getNotificationMessage)
      .subscribe(notificationMessage => {
        if (notificationMessage) {
          notieAlert({ type: 'error', text: notificationMessage, stay: true });
        }
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
